// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select {
  width: 200px;
  margin-top: 20px;
  margin-left: 10px;
  padding-bottom: 5px;
}

.warn {
  width: 200px;
  margin-left: 10px;
  padding-top: 0px;
  margin-bottom: 10px;
  font-size: 11px;
  color: #e30526;
}

.warningMsg {
  font-size: 12px !important;
}

.aplRouter {
  bottom: 0px;
  position: absolute;
  width: 100% !important;
  margin: 0px;
  padding: 0px;
}

.button {
  margin-left: 20px;
  margin-top: 10px;
  width: 175px;
  text-align: center;
}

.mat-icon {
  margin-bottom: 5px;
}

.label {
  margin-top: 10px;
  margin-left: 10px;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 17px;
}

.table {
  margin: 10px;
}

.table-header {
  font-weight: bold;
  background-color: #f2f2ef;
  color: #3b3b39;
  font-size: 15pt;
  text-align: center;
  margin-top: 2px;
  margin-bottom: 2px;
  padding-bottom: 7px;
  padding-top: 5px;
}

.segment {
  font-weight: bold;
  background-color: #7b7b7b;
  color: #ffffff;
  margin-top: 5px;
  padding-left: 10px;
  padding-bottom: 5px;
  padding-top: 3px;
}

.region {
  font-weight: bold;
  margin-top: 3px;
  padding-left: 15px;
  border-bottom: 1px solid black;
  padding-bottom: 4px;
}

.menu-relative {
  display: flex;
  width: 100%;
  overflow-y: inherit;
}

.header-style {
  font-weight: bold;
  font-size: 15px;
  width: 60px !important;
  text-align: left;
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.mat-mdc-cell {
  width: 10px;
  word-break: break-all;
  border-right: 1px solid #d7d7d7;
  padding-left: 5px !important;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 13px;
}

tr.mat-mdc-header-row {
  height: 20px !important;
  padding-top: 3px !important;
}

.table-div {
  width: 100%;
  padding-bottom: 20px;
  overflow: hidden;
}

.mat-mdc-row,
.mat-mdc-header-row {
  height: 35px;
  white-space: nowrap;
}

.mat-mdc-table-div {
  overflow: auto;
  max-height: 82vh;
}

.check-mark {
  padding-left: 7px;
}

.message {
  background-color: yellow;
  border: 1px solid black;
  padding: 3px;
  margin-bottom: 9px;
  border-radius: 5px;
  font-weight: bold;
}

.center-year-col {
  text-align: center;
  font-weight: bold;
  width: 100%;
}

.color-background {
  background-color: #0072ce;
  border-radius: 2px;
}

:host ::ng-deep .p-multiselect-panel {
  width: 200px;
}

:host ::ng-deep .p-select {
  width: 200px;
}

:host ::ng-deep .p-datatable-header {
  background-color: #f2f2ef;
  font-size: 25px;
  text-align: center;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/reports/propulsion-rollout/propulsion-rollout.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;AACF;;AAEA;EACE,WAAA;EACA,qBAAA;EACA,+BAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,uBAAA;EACA,2BAAA;AACF;;AAEA;EACE,WAAA;EACA,oBAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,wBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,WAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AACA;EACE,YAAA;AAEF;;AAAA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;AAGF;AACA,ozKAAozK","sourcesContent":[".select {\n  width: 200px;\n  margin-top: 20px;\n  margin-left: 10px;\n  padding-bottom: 5px;\n}\n\n.warn {\n  width: 200px;\n  margin-left: 10px;\n  padding-top: 0px;\n  margin-bottom: 10px;\n  font-size: 11px;\n  color: #e30526;\n}\n\n.warningMsg {\n  font-size: 12px !important;\n}\n\n.aplRouter {\n  bottom: 0px;\n  position: absolute;\n  width: 100% !important;\n  margin: 0px;\n  padding: 0px;\n}\n\n.button {\n  margin-left: 20px;\n  margin-top: 10px;\n  width: 175px;\n  text-align: center;\n}\n\n.mat-icon {\n  margin-bottom: 5px;\n}\n\n.label {\n  margin-top: 10px;\n  margin-left: 10px;\n  margin-bottom: 10px;\n  font-weight: bold;\n  font-size: 17px;\n}\n\n.table {\n  margin: 10px;\n}\n\n.table-header {\n  font-weight: bold;\n  background-color: #f2f2ef;\n  color: #3b3b39;\n  font-size: 15pt;\n  text-align: center;\n  margin-top: 2px;\n  margin-bottom: 2px;\n  padding-bottom: 7px;\n  padding-top: 5px;\n}\n\n.segment {\n  font-weight: bold;\n  background-color: #7b7b7b;\n  color: #ffffff;\n  margin-top: 5px;\n  padding-left: 10px;\n  padding-bottom: 5px;\n  padding-top: 3px;\n}\n\n.region {\n  font-weight: bold;\n  margin-top: 3px;\n  padding-left: 15px;\n  border-bottom: 1px solid black;\n  padding-bottom: 4px;\n}\n\n.menu-relative {\n  display: flex;\n  width: 100%;\n  overflow-y: inherit;\n}\n\n.header-style {\n  font-weight: bold;\n  font-size: 15px;\n  width: 60px !important;\n  text-align: left;\n  padding-left: 5px !important;\n  padding-right: 5px !important;\n}\n\n.mat-mdc-cell {\n  width: 10px;\n  word-break: break-all;\n  border-right: 1px solid #d7d7d7;\n  padding-left: 5px !important;\n  padding-right: 5px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  font-size: 13px;\n}\n\ntr.mat-mdc-header-row {\n  height: 20px !important;\n  padding-top: 3px !important;\n}\n\n.table-div {\n  width: 100%;\n  padding-bottom: 20px;\n  overflow: hidden;\n}\n\n.mat-mdc-row,\n.mat-mdc-header-row {\n  height: 35px;\n  white-space: nowrap;\n}\n\n.mat-mdc-table-div {\n  overflow: auto;\n  max-height: 82vh;\n}\n\n.check-mark {\n  padding-left: 7px;\n}\n\n.message {\n  background-color: yellow;\n  border: 1px solid black;\n  padding: 3px;\n  margin-bottom: 9px;\n  border-radius: 5px;\n  font-weight: bold;\n}\n\n.center-year-col {\n  text-align: center;\n  font-weight: bold;\n  width: 100%;\n}\n\n.color-background {\n  background-color: #0072ce;\n  border-radius: 2px;\n}\n\n:host ::ng-deep .p-multiselect-panel {\n  width: 200px;\n}\n:host ::ng-deep .p-select {\n  width: 200px;\n}\n:host ::ng-deep .p-datatable-header {\n  background-color: #f2f2ef;\n  font-size: 25px;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
